export const boostActions = {
    show: 'show',
    enabled: 'enabled',
    disabled: 'disabled',
    optIn: 'optin',
    optOut: 'optout',
};
export const boostLabels = {
    swipe: 'swipe',
    tooltip: 'tooltip',
    button: 'button',
};
export const category = {
    boost: 'boost',
};
